import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button, Grid, Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import React from "react";
import { connect } from "react-redux";
import { ButtonCompo } from "../../components/Comman/Button";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import { withRouter } from "../../components/withRouter";
import endpoint from "../../config/endpoints";
import {
  savemsg,
  saveWarningMsg,
  serverMsg
} from "../../config/messageconstant";
import { getSalesExecutiveByUserType } from "../../Slice/salesExecutive.slice";
import { apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { downloadExcel, downloadF } from "../PDF/PDFDownload";
import ImportPopUp from "./ImportPopUp";
const ExcelJS = require("exceljs");

class ProductImportExport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fromDate: dayjs(),
      toDate: dayjs(),
      salesTeam: "",
      searchValue: "",
      importPopUpFlag: false,
      validatedProductList: [],
      hasErrorRow: false,
    };

    this.tableStyles = {
      tabContainer: {
        display: "flex",
        marginBottom: "16px",
        borderBottom: "1px solid #E5F1F9",
      },
      tableWrapper: {
        maxHeight: "570px",
        overflowY: "auto",
        overflowX: "auto", // Enable horizontal scrolling
        width: "100%",
        border: "1px solid rgb(182, 186, 188)",
        borderRadius: "8px",
      },
      table: {
        minWidth: "2800px", // Minimum width to ensure all columns are visible
        width: "max-content", // Allow table to grow based on content
        borderCollapse: "collapse",
        tableLayout: "auto", // Auto layout for flexible column sizing
      },
      stickyHeader: {
        position: "sticky",
        top: 0,
        backgroundColor: "rgb(233, 240, 243)",
        zIndex: 10,
      },
      tab: {
        padding: "8px 16px",
        cursor: "pointer",
        color: "#333",
        fontSize: "14px",
        fontWeight: "500",
        transition: "color 0.2s ease-in-out",
      },
      activeTab: {
        color: "#1C4E80",
        borderBottom: "2px solid #1C4E80",
      },
      noData: {
        padding: "16px",
        textAlign: "center",
        fontSize: "14px",
        color: "#666",
      },
      tableContainer: {
        backgroundColor: "#fff",
        borderRadius: "10px",
        padding: "16px",
        maxWidth: "100%", // Allow full width usage
        margin: "0 auto",
        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
      },
      searchContainer: {
        marginBottom: "16px",
        display: "flex",
        alignItems: "center",
        maxWidth: "300px",
      },
      headerRow: {
        backgroundColor: "rgb(233, 240, 243)",
        color: "#000",
        fontWeight: "bold",
        fontSize: "14px",
      },
      headerCell: {
        padding: "12px 8px", // Reduced horizontal padding for better space utilization
        textAlign: "center",
        borderBottom: "2px solid #E5F1F9",
        borderRight: "1px solid #E5F1F9", // Add right border for better column separation
        fontWeight: 600,
        whiteSpace: "nowrap", // Prevent text wrapping in headers
        position: "sticky",
        top: 0,
        backgroundColor: "rgb(233, 240, 243)",
      },
      dataRow: {
        backgroundColor: "#fff",
        transition: "background-color 0.2s ease-in-out",
      },
      dataRowHover: {
        backgroundColor: "#E5F1F9",
      },
      dataCell: {
        padding: "12px 8px", // Reduced horizontal padding
        fontSize: "13px",
        color: "#333",
        borderBottom: "1px solid #E5F1F9",
        borderRight: "1px solid #E5F1F9", // Add right border for better column separation
        whiteSpace: "nowrap", // Prevent text wrapping
        overflow: "hidden",
        textOverflow: "ellipsis", // Show ellipsis for long text
      },
      amountCell: {
        color: "#004969",
        fontWeight: "500",
        fontSize: "13px",
      },
      alternateRow: {
        backgroundColor: "#fff",
      },
      searchInput: {
        width: "100%",
        padding: "8px 12px",
        fontSize: "14px",
        border: "1px solid #E5F1F9",
        borderRadius: "6px",
        outline: "none",
        color: "#333",
        transition: "border-color 0.3s ease-in-out",
      },
      searchInputFocus: {
        borderColor: "#1C4E80",
        boxShadow: "0 0 5px rgba(28, 78, 128, 0.3)",
      },
    };
  }

  onClickOfExport = () => {
    const { showLoador, showNotification } = this.props;

    showLoador({ loador: true });
    downloadF({
      isGet: true,
      url: endpoint.exportData + "/product-export-excel",
      ext: "xls",
      openNewTab: false,
      isShowSalesPersonName: true,
      reportName: "Product-Import-Export",
    }).then((response) => {
      showLoador({ loador: false });
      if (!response) {
        showNotification({
          msg: serverMsg,
          severity: "error",
        });
      }
    });
  };

  onClickOfImport = () => {
    this.setState({ importPopUpFlag: true });
  };

  onSearchBox = (e) => {
    this.setState({
      searchValue: e.target.value,
    });
  };

  getFilteredTableData = (searchData) => {
    const { searchValue } = this.state;
    return searchData.filter((currentRow) => {
      let isValid = false;

      let categoryName = currentRow?.category?.name;
      let subCategoryName = currentRow?.subCategory?.name;
      let groupName = currentRow?.group?.name;
      let groupCode = currentRow?.group?.code;
      let groupDescription = currentRow?.group?.description;
      let packagingTypeName = currentRow?.packagingType?.name;
      let cgst = currentRow?.tax?.cgst;
      let sgst = currentRow?.tax?.sgst;
      let igst = currentRow?.tax?.igst;
      let cess = currentRow?.tax?.cess;
      let hsnCode = currentRow?.tax?.hsnCode;
      let stockHolderUom = currentRow?.stockStakeUom?.name;
      let outletUom = currentRow?.outletUom?.name;
      let tag = currentRow?.tag?.name;
      let productName = currentRow?.product?.name;
      let uomConversionValue =
        currentRow.flag == 0
          ? currentRow?.product?.uomConversionValue
          : currentRow?.productConversionValue;
      let productCode = currentRow?.product?.code;
      let weight =
        currentRow.flag == 0 ? currentRow?.product?.weight : currentRow?.weight;
      let shelfLife = currentRow?.product?.selfLife;

      if (
        (categoryName &&
          categoryName
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["errorMessage"] &&
          currentRow["errorMessage"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (subCategoryName &&
          subCategoryName
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (groupName &&
          groupName
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (groupCode &&
          groupCode
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (groupDescription &&
          groupDescription
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (packagingTypeName &&
          packagingTypeName
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (cgst &&
          cgst
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (sgst &&
          sgst
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (igst &&
          igst
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (sgst &&
          sgst
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (cess &&
          cess
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (hsnCode &&
          hsnCode
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (stockHolderUom &&
          stockHolderUom
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (outletUom &&
          outletUom
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (tag &&
          tag
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (productName &&
          productName
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (uomConversionValue &&
          uomConversionValue
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (productCode &&
          productCode
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (weight &&
          weight
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (shelfLife &&
          shelfLife
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase()))
      ) {
        isValid = true;
        return true;
      }
    });
  };

  onSubmit = () => {
    const { showLoador, showNotification } = this.props;
    const { validatedProductList } = this.state;

    let dataToSendList =
      validatedProductList.length !== 0 ? validatedProductList : [];

    swal({
      title: "Are you sure?",
      text: saveWarningMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        showLoador({ loador: true });
        apiPost({
          url: endpoint.importData + "/validated-product-hierarchy-data",
          postBody: dataToSendList,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({
              msg: serverMsg,
              severity: "error",
            });
          } else {
            if (data && data.data && data.data.statusCode == 500) {
              showNotification({
                msg: data.data.message,
                severity: "error",
              });
            } else {
              showNotification({
                msg: savemsg,
              });
              window.location.reload();
            }
          }
        });
      }
    });
  };

  importPopUpClose = () => {
    this.setState({ importPopUpFlag: false });
  };

  dataMethod = (dataObj) => {
    const hasErrorRow = dataObj.some((item) => item.flag == 1);

    this.setState({ validatedProductList: dataObj, hasErrorRow });
  };

  filterExcel = () => {
    const { validatedProductList } = this.state;

    if (validatedProductList.length === 0) {
      this.props.showNotification({
        msg: "No data available for export",
        severity: "error",
      });
      return;
    }

    const filteredData = this.getFilteredTableData(validatedProductList);

    if (!filteredData || filteredData.length === 0) {
      this.props.showNotification({
        msg: "No data available for export",
        severity: "error",
      });
      return;
    }

    // Prepare column headers & rows
    const excelHeaders = [
      "Employee Code",
      "Sales Person Name",
      "Designation",
      "Date",
      "Day",
      "Beat",
    ];

    const formattedRows = filteredData.map((row) => [
      row.employeeCode || "-",
      row.salesTeamName || "-",
      row.designation || "-",
      row.dmyDate || "-",
      row.dayName || "-",
      row.beatNames || "-",
    ]);

    // ---------------- Excel Generation Code ----------------
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet 1");

    // Put headers directly in first row (skip title & extra rows)
    excelHeaders.forEach((header, index) => {
      const cell = worksheet.getCell(1, index + 1);
      cell.value = header;
      cell.font = { bold: true, size: 12 };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
      cell.alignment = { vertical: "middle", horizontal: "center" };
    });

    // Add data rows
    formattedRows.forEach((rowData) => {
      worksheet.addRow(rowData);
    });

    // Auto column width
    worksheet.columns.forEach((column) => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const cellValue = cell.value ? cell.value.toString() : "";
        maxLength = Math.max(maxLength, cellValue.length);
      });
      column.width = maxLength < 10 ? 10 : maxLength + 2;
    });

    // Freeze header row
    worksheet.views = [{ state: "frozen", ySplit: 1 }];

    // Download file
    const fileName = "Product_Export" + " - " + new Date();
    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = fileName + ".xls";
      anchor.click();
      window.URL.revokeObjectURL(url);
    });
  };

  render() {
    const {
      fromDate,
      toDate,
      salesTeam,
      importPopUpFlag,
      validatedProductList,
      hasErrorRow,
    } = this.state;

    return (
      <>
        <Paper
          sx={{
            borderRadius: 2,
            p: { xs: 2, sm: 4 },
            boxShadow: "0 6px 32px rgba(0,0,0,0.08)",
            // background: "linear-gradient(135deg,rgb(251, 251, 251) 0%,rgb(238, 247, 250) 100%)",
            maxWidth: "auto",
            margin: "auto",
          }}
          elevation={5}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <LandingScreenHeader
              screenTitle="Import Product"
              showSaveBtnMain={false}
              showAddButton={false}
              showBackButton={false}
            />

            <div style={{ display: "flex", gap: 15 }}>
              <Button
                variant="outlined"
                color="secondary"
                size="medium"
                startIcon={<CloudDownloadIcon />}
                sx={{
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                  transition: "all 0.2s",
                  minWidth: "120px",
                  height: "35px",
                  "&:hover": {
                    backgroundColor: "#f4f6fa",
                    borderColor: "#1976d2",
                    color: "#1976d2",
                    transform: "translateY(-2px)",
                  },
                }}
                onClick={this.onClickOfExport}
              >
                Export
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="medium"
                startIcon={<CloudUploadIcon sx={{ color: "#fff" }} />}
                sx={{
                  color: "#fff",
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                  transition: "all 0.2s",
                  minWidth: "150px",
                  height: "35px",
                  "&:hover": {
                    backgroundColor: "#1976d2",
                    transform: "translateY(-2px)",
                  },
                }}
                onClick={this.onClickOfImport}
              >
                Import
              </Button>
            </div>
          </div>
          <br />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "5px",
            }}
          >
            {/* Search Box */}
            <input
              type="text"
              placeholder="Search..."
              value={this.state.searchValue}
              onChange={this.onSearchBox}
              style={{
                padding: "6px 10px",
                fontSize: "14px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                width: "230px",
              }}
            />
          </div>
          {/* Updated table JSX with improved scrolling and width management */}
          <div style={this.tableStyles.tableWrapper}>
            <table style={this.tableStyles.table}>
              <thead style={this.tableStyles.stickyHeader}>
                <tr style={this.tableStyles.headerRow}>
                  <th
                    style={{ ...this.tableStyles.headerCell, minWidth: "60px" }}
                  >
                    Sr.No
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "120px",
                      textAlign: "left",
                    }}
                  >
                    Category Name
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "140px",
                      textAlign: "left",
                    }}
                  >
                    Sub Category Name
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "120px",
                      textAlign: "left",
                    }}
                  >
                    Group Name
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "100px",
                    }}
                  >
                    Group Code
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "150px",
                      textAlign: "left",
                    }}
                  >
                    Group Description
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "140px",
                      textAlign: "left",
                    }}
                  >
                    Packaging Type Name
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "180px",
                      textAlign: "left",
                    }}
                  >
                    Packaging Type Description
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "80px",
                      textAlign: "right",
                    }}
                  >
                    CGST
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "80px",
                      textAlign: "right",
                    }}
                  >
                    SGST
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "80px",
                      textAlign: "right",
                    }}
                  >
                    IGST
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "80px",
                      textAlign: "right",
                    }}
                  >
                    Cess
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "120px",
                      textAlign: "center",
                    }}
                  >
                    Tax Hsn Code
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "140px",
                      textAlign: "left",
                    }}
                  >
                    Stake Holder UOM
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "100px",
                      textAlign: "left",
                    }}
                  >
                    Outlet UOM
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "80px",
                      textAlign: "left",
                    }}
                  >
                    Tag
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "150px",
                      textAlign: "left",
                    }}
                  >
                    Product Name
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "120px",
                    }}
                  >
                    Product Conversion Value
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "100px",
                    }}
                  >
                    Product Code
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "120px",
                      textAlign: "left",
                    }}
                  >
                    Product Short Name
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "100px",
                      textAlign: "right",
                    }}
                  >
                    Product Weight (In Grams)
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "150px",
                      textAlign: "left",
                    }}
                  >
                    Product Description
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "100px",
                      textAlign: "right",
                    }}
                  >
                    Product Shelf Life (In Months)
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "200px",
                      textAlign: "left",
                    }}
                  >
                    Error Message
                  </th>
                </tr>
              </thead>
              <tbody>
                {validatedProductList.length !== 0 &&
                  this.getFilteredTableData(validatedProductList).map(
                    (row, index) => (
                      <tr
                        key={index + 1}
                        style={{
                          ...this.tableStyles.dataRow,
                          ...this.tableStyles.alternateRow,
                          ...(index % 2 === 0
                            ? this.tableStyles.alternateRow
                            : {}),
                          ...(row.flag == 1 && { backgroundColor: "#ed8e98" }),
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor =
                            this.tableStyles.dataRowHover.backgroundColor;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor =
                            row.flag == 1
                              ? "#ed8e98"
                              : index % 2 === 0
                              ? this.tableStyles.alternateRow.backgroundColor
                              : this.tableStyles.dataRow.backgroundColor;
                        }}
                      >
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "60px",
                            textAlign: "center",
                          }}
                        >
                          {index + 1}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "120px",
                            textAlign: "left",
                          }}
                        >
                          {row.category !== null && row.category.name
                            ? row.category.name
                            : "-"}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "140px",
                            textAlign: "left",
                          }}
                        >
                          {row.subCategory !== null &&
                          row.subCategory.name !== null
                            ? row.subCategory.name
                            : "-"}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "120px",
                            textAlign: "left",
                          }}
                        >
                          {row.group !== null && row.group.name !== null
                            ? row.group.name
                            : "-"}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "100px",
                            textAlign: "center",
                          }}
                        >
                          {row.group !== null && row.group.code !== null
                            ? row.group.code
                            : "-"}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "150px",
                            textAlign: "left",
                          }}
                        >
                          {row.group !== null && row.group.description !== null
                            ? row.group.description
                            : "-"}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "140px",
                            textAlign: "left",
                          }}
                        >
                          {row.packagingType !== null &&
                          row.packagingType.name !== null
                            ? row.packagingType.name
                            : "-"}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "180px",
                            textAlign: "left",
                          }}
                        >
                          {row.packagingType !== null &&
                          row.packagingType.description !== null
                            ? row.packagingType.description
                            : "-"}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "80px",
                            textAlign: "right",
                          }}
                        >
                          {row.tax !== null && row.tax.cgst !== null
                            ? row.tax.cgst
                            : "-"}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "80px",
                            textAlign: "right",
                          }}
                        >
                          {row.tax !== null && row.tax.sgst !== null
                            ? row.tax.sgst
                            : "-"}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "80px",
                            textAlign: "right",
                          }}
                        >
                          {row.tax !== null && row.tax.igst !== null
                            ? row.tax.igst
                            : "-"}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "80px",
                            textAlign: "right",
                          }}
                        >
                          {row.tax !== null && row.tax.cess !== null
                            ? row.tax.cess
                            : "-"}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "120px",
                            textAlign: "center",
                          }}
                        >
                          {row.tax !== null && row.tax.hsnCode !== null
                            ? row.tax.hsnCode
                            : "-"}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "140px",
                            textAlign: "left",
                          }}
                        >
                          {row.stockStakeUom !== null &&
                          row.stockStakeUom.name !== null
                            ? row.stockStakeUom.name
                            : "-"}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "100px",
                            textAlign: "left",
                          }}
                        >
                          {row.outletUom !== null && row.outletUom.name !== null
                            ? row.outletUom.name
                            : "-"}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "80px",
                            textAlign: "left",
                          }}
                        >
                          {row.tag !== null && row.tag.name !== null
                            ? row.tag.name
                            : "-"}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "150px",
                            textAlign: "left",
                          }}
                        >
                          {row.product !== null && row.product.name !== null
                            ? row.product.name
                            : "-"}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "120px",
                            textAlign: "right",
                          }}
                        >
                          {row.flag == 0
                            ? row.product !== null &&
                              row.product.uomConversionValue !== null
                              ? row.product.uomConversionValue
                              : "-"
                            : row.productConversionValue !== null
                            ? row.productConversionValue
                            : "-"}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "100px",
                            textAlign: "center",
                          }}
                        >
                          {row.product !== null && row.product.code !== null
                            ? row.product.code
                            : "-"}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "120px",
                            textAlign: "left",
                          }}
                        >
                          {row.product !== null &&
                          row.product.shortName !== null
                            ? row.product.shortName
                            : "-"}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "100px",
                            textAlign: "right",
                          }}
                        >
                          {row.flag == 0
                            ? row.product !== null &&
                              row.product.weight !== null
                              ? row.product.weight
                              : "-"
                            : row.weight !== null
                            ? row.weight
                            : "-"}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "150px",
                            textAlign: "left",
                          }}
                        >
                          {row.product !== null &&
                          row.product.description !== null
                            ? row.product.description
                            : "-"}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "100px",
                            textAlign: "right",
                          }}
                        >
                          {row.product !== null && row.product.selfLife !== null
                            ? row.product.selfLife
                            : "-"}
                        </td>
                        {row.flag == 1 ? (
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              minWidth: "200px",
                              textAlign: "left",
                            }}
                          >
                            {row.errorMessage !== null ? row.errorMessage : "-"}
                          </td>
                        ) : (
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              minWidth: "200px",
                              textAlign: "center",
                            }}
                          >
                            {"-"}
                          </td>
                        )}
                      </tr>
                    )
                  )}

                {validatedProductList.length === 0 && (
                  <tr>
                    <td colSpan="18" style={this.tableStyles.noData}>
                      No Data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {validatedProductList.length !== 0 && !hasErrorRow && (
            <>
              <Grid
                item
                sm={12}
                xs={12}
                md={12}
                lg={12}
                rowSpacing={2}
                columnSpacing={{ xs: 12, sm: 6, md: 1 }}
                container
                justifyContent="right"
                sx={{ marginTop: 3 }}
              >
                <ButtonCompo
                  size="medium"
                  type="submit"
                  variant="contained"
                  name="Submit"
                  onClick={this.onSubmit}
                />
              </Grid>
            </>
          )}

          {importPopUpFlag && (
            <ImportPopUp
              open={importPopUpFlag}
              handleCloses={this.importPopUpClose}
              dataMethod={this.dataMethod}
            />
          )}
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  salesPersonList: state.salesExecutive,
});

const mapDispatchToProps = {
  showLoador,
  showNotification,
  downloadExcel,
  getSalesExecutiveByUserType,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(ProductImportExport);
